import { API } from "../APIs/index";
import areas from "../helpers/json/area.json";
import { States } from "../helpers/States";
import { Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export default class AgentService {
  tokens: any | Tokens;
  get = API.agent + "get/";
  post = API.agent + "post/";
  delete = API.agent + "delete/";
  put = API.agent + "put/";
  agentTransfer = API.transfersFloat;
  Areas: any;
  getNewDashboard = API.newDashboard;
  TransactionDashboard = API.transactionDashboard+"get/";
  constructor() {
    this.tokens = TokenValidator();
  }

  async getAgents(data: any) {
    try {
      let response = await fetch(
        this.get +
          `Agent/getPaged/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAllAgents(data: any) {
    try {
      let response = await fetch(
        this.get + `agent/count/1/50/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentsPerformance(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard +
          `Performance/getagentperformance/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getStateCordinatorPerformance(data: any) {
    try {
      let response = await fetch(
        this.getNewDashboard +
          `Performance/getstatecoordinatorperformance/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getUser(phoneNumber: string) {
    try {
      let response = await fetch(
        this.get + `aggregator/findBy/${phoneNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }


  async getAgentByPhoneNumber(phoneNumber: string) {
    try {
      let response = await fetch(
        this.get + `agent/findBy/${phoneNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }


  async getState() {
    try {
      return States;
    } catch (err) {
      throw err;
    }
  }

  async getAreasByState(state: string) {
    try {
      for (const x in areas) {
        if (areas.hasOwnProperty(x)) {
          if (areas[x].state.name === state) {
            this.Areas = areas[x].state.locals;
          }
        }
      }

      return await this.Areas;
    } catch (err) {
      throw err;
    }
  }

  async onboardAgents(data: any) {
    try {
      let response = await fetch(
        this.post + `Agent/tradepartner/onboard-agent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async updateAgent(data: any) {
    try {
      let response = await fetch(this.put + `agent`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async requestAgentFloat(data: any) {
    try {
      let response = await fetch(this.agentTransfer + `float-agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentByPhone(phoneNumber: any) {
    try {
      let response = await fetch(this.get + `agent/findBy/${phoneNumber}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
  async addPNDToAgentServices(data: any) {
    try {
      let response = await fetch(
        this.post + `agent/Account/TradePartner/TogglePnd`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async inviteAgent(data: any) {
    try {
      let response = await fetch(this.post + `agent/v2/inviteAgent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async putAccountPNDService(data: any) {
    try {
      let response = await fetch(
        this.post + `agent/Account/TradePartner/TogglePnd`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentDetails(id: any) {
    try {
      let response = await fetch(this.get + `agent/getDetails/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAggregatorPerformanceService(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard +
          `Performance/getaggregatorperformance/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getLocationPerformanceService(data: any) {
    try {
      let response = await fetch(
        this.TransactionDashboard +
          `Dashboard/getlocationperformance/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getRMPerformanceService(data: any) {
    try {
      let response = await fetch(
        this.getNewDashboard +
          `Performance/getregioncoordinatorperformance/${data.page}/${data.pageSize}/${data.whereCondition}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
